import { combineReducers } from 'redux';
import { getJSON } from 'redux-api-middleware';

import apiGenerator from '../apiGenerator';
import Item, { itemToApiMap } from '../../models/Item';
import { mapApiToModel } from '../../models/modelMapper';
import defaultSplitAttributes from '../../config/defaultSplitAttributes';
import { CollectionFilterTypes } from '../../config/constants';
import { ADD_NEW_ITEM_SUCCESS, UPDATE_ITEM_SUCCESS, DELETE_ITEM_SUCCESS } from './items';

// Actions
const GET_COLLECTIONS_REQUEST = 'ctm/collections/GET_COLLECTIONS_REQUEST';
const GET_COLLECTIONS_SUCCESS = 'ctm/collections/GET_COLLECTIONS_SUCCESS';
const GET_COLLECTIONS_FAILURE = 'ctm/collections/GET_COLLECTIONS_FAILURE';
const CHANGE_CATEGORY_SPLIT_ATTR = 'ctm/collections/CHANGE_CATEGORY_SPLIT_ATTR';
const CHANGE_FILTER_TYPE = 'ctm/collections/CHANGE_FILTER_TYPE';

// Action Creators
export function fetchCollections() {
  return apiGenerator({
    endpoint: 'collections',
    method: 'GET',
    types: [
      GET_COLLECTIONS_REQUEST,
      {
        type: GET_COLLECTIONS_SUCCESS,
        payload: async (action, state, res) =>
          getJSON(res).then(data => data.map(d => mapApiToModel(d, itemToApiMap, Item))),
      },
      GET_COLLECTIONS_FAILURE,
    ],
  });
}

export function changeCatSplit(category, splitAttr) {
  return {
    type: CHANGE_CATEGORY_SPLIT_ATTR,
    payload: {
      category,
      splitAttr,
    },
  };
}

export function changeFilterType(newFilterType) {
  return {
    type: CHANGE_FILTER_TYPE,
    payload: newFilterType,
  };
}

// Reducers
export function items(state = [], action) {
  switch (action.type) {
    case GET_COLLECTIONS_SUCCESS:
      return action.payload;
    case UPDATE_ITEM_SUCCESS: {
      const updatedItem = action.payload;
      return [...state.filter(i => i.id !== updatedItem.id), updatedItem];
    }
    case ADD_NEW_ITEM_SUCCESS:
      return [...state, action.payload];
    case DELETE_ITEM_SUCCESS:
      return state.filter(i => i.id !== action.meta.id);
    default:
      return state;
  }
}

export function catSplitAttributes(state = defaultSplitAttributes, action) {
  switch (action.type) {
    case CHANGE_CATEGORY_SPLIT_ATTR:
      return Object.assign({}, state, {
        [action.payload.category]: action.payload.splitAttr,
      });
    default:
      return state;
  }
}

export function isFetching(state = false, action) {
  switch (action.type) {
    case GET_COLLECTIONS_REQUEST:
      return !action.error;
    case GET_COLLECTIONS_SUCCESS:
    case GET_COLLECTIONS_FAILURE:
      return false;
    default:
      return state;
  }
}

export function fetched(state = false, action) {
  switch (action.type) {
    case GET_COLLECTIONS_SUCCESS:
      return true;
    default:
      return state;
  }
}

export function filterType(state = CollectionFilterTypes.IN_COLL, action) {
  switch (action.type) {
    case CHANGE_FILTER_TYPE:
      return action.payload;
    default:
      return state;
  }
}

export default combineReducers({
  items,
  isFetching,
  fetched,
  catSplitAttributes,
  filterType,
});



// WEBPACK FOOTER //
// ./src/redux/ducks/collections.js